import { render, staticRenderFns } from "./c_home_title.vue?vue&type=template&id=6788464d&scoped=true"
import script from "./c_home_title.vue?vue&type=script&lang=js"
export * from "./c_home_title.vue?vue&type=script&lang=js"
import style0 from "./c_home_title.vue?vue&type=style&index=0&id=6788464d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6788464d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6788464d')) {
      api.createRecord('6788464d', component.options)
    } else {
      api.reload('6788464d', component.options)
    }
    module.hot.accept("./c_home_title.vue?vue&type=template&id=6788464d&scoped=true", function () {
      api.rerender('6788464d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_home_title.vue"
export default component.exports